<div class="ttt ttt-error" aria-live="assertive">
  @if (toastRef.data.pathIcon.includes('/')) {
    <img src="{{ toastRef.data.pathIcon }}" alt="Toast icon" />
  } @else {
    <mat-icon fontSet="material-icons">{{ toastRef.data.pathIcon }}</mat-icon>
  }

  <div class="ttt-content">
    <div *ngIf="toastRef.data.textTitle" class="ttt-title">
      {{ toastRef.data.textTitle }}
    </div>
    <div class="ttt-message">
      {{ toastRef.data.textBody }}
    </div>
  </div>
</div>
